export default {
  Address: "Dirección",
  Street1: "Calle y número", 
  Street2: "Calle 2",
  City: "Ciudad",
  County: "Condado",
  State: "Estado",
  ZipCode: "Código Postal",
  Contact: "Contacto",
  MobilePhone: "Teléfono Móvil",
  HomePhone: "Teléfono de Casa",
  WorkPhone: "Teléfono de Trabajo",
  EmailAddress: "Correo Electrónico",
  FaxNumber: "Número de Fax",
  PolicyCoverages: "Coberturas de Póliza",
  LiabilityBiLimit: "Límite de Responsabilidad por Lesiones Corporales",
  LiabilityPdLimit: "Límite de Responsabilidad por Daños a la Propiedad",
  MedPayLimit: "Límite de Pago Médico",
  UninsuredMotoristBiLimit: "Límite de Motorista Sin Seguro BI",
  UnderinsuredMotoristBiLimit: "Límite de Motorista con Seguro Insuficiente BI",
  AccidentalDeathLimit: "Límite por Muerte Accidental",
  VehicleCoverages: "Coberturas de Vehículo",
  CollisionDeductible: "Deducible por Colisión",
  ComprehensiveDeductible: "Deducible Integral",
  CustomEquipmentValue: "Valor de Equipo Personalizado",
  GapCoverage: "Cobertura de Brecha",
  RentalLimit: "Límite de Alquiler",
  TowingLimit: "Límite de Remolque",
  SafetyGlassCoverage: "Cobertura de Cristales de Seguridad",
  Customer: "Cliente",
  Identifier: "Identificador",
  FirstName: "Nombre",
  MiddleName: "Segundo Nombre",
  LastName: "Apellido",
  DeclinedEmail: "Correo Electrónico Rechazado",
  DeclinedPhone: "Teléfono Rechazado",
  PriorAddress: "Dirección Anterior",
  ContactInformation: "Información de Contacto",
  MonthsAtResidence: "Meses en la Residencia",
  CustomerDeclinedCredit: "Cliente Rechazó Crédito",
  NumberOfResidentsInHousehold: "Número de Residentes en el Hogar",
  PriorInsuranceInformation: "Información de Seguro Anterior",
  Discounts: "Descuentos",
  CompanionPolicies: "Pólizas Complementarias",
  DistantStudent: "Estudiante Distante",
  DriversTraining: "Entrenamiento de Conductores",
  GoodStudent: "Buen Estudiante",
  SingleParent: "Padre/Madre Soltero(a)",
  AccidentPrevention: "Prevención de Accidentes",
  AccidentPreventionCourseDate: "Fecha del Curso de Prevención de Accidentes",
  SeniorDriverDiscount: "Descuento para Conductor Senior",
  SeniorDriverCourseDate: "Fecha del Curso de Conductor Senior",
  MultiplePolicies: "Múltiples Pólizas",
  CompanionPolicy: "Póliza Complementaria",
  LineOfBusiness: "Línea de Negocio",
  Driver: "Conductor",
  DriverId: "ID del Conductor",
  DateOfBirth: "Fecha de Nacimiento",
  Gender: "Género",
  MaritalStatus: "Estado Civil",
  MonthsEmployed: "Meses Empleado",
  IndustryOccupation: "Ocupación en la Industria",
  LicenseInformation: "Información de Licencia",
  Attributes: "Atributos",
  FinancialResponsibilityInformation:
    "Información de Responsabilidad Financiera",
  Violations: "Infracciones",
  DriverAttributes: "Atributos del Conductor",
  EducationLevel: "Nivel de Educación",
  OccasionalOperator: "Operador Ocasional",
  PropertyInsurance: "Seguro de Propiedad",
  Relation: "Relación",
  ResidencyStatus: "Estado de Residencia",
  ResidencyType: "Tipo de Residencia",
  MilesToWork: "Millas al Trabajo",
  DriverLicenseInformation: "Información de Licencia de Conducir",
  LicenseStatus: "Estado de la Licencia",
  LicenseNumber: "Número de Licencia",
  MonthsForeignLicense: "Meses con Licencia Extranjera",
  MonthsLicensed: "Meses con Licencia",
  MonthsStateLicensed: "Meses con Licencia Estatal",
  MonthsMvrExperience: "Meses de Experiencia MVR",
  MonthsSuspended: "Meses Suspendido",
  StateLicensed: "Estado de la Licencia",
  CountryOfOrigin: "País de Origen",
  ForeignNational: "Extranjero",
  InternationalDriversLicense: "Licencia de Conducir Internacional",
  Sr22: "Sr22",
  Sr22Reason: "Razón del Sr22",
  Sr22State: "Estado del Sr22",
  Sr22Date: "Fecha del Sr22",
  SR22CaseNumber: "Número de Caso SR22",
  LienholderInformation: "Información del Acreedor",
  LienHolderName: "Nombre del Acreedor",
  PhoneNumber: "Número de Teléfono",
  LienHolderType: "Tipo de Acreedor",
  MiscellaneousFee: "Tarifa Miscelánea",
  Amount: "Cantidad",
  ApplyToDownPayment: "Aplicar al Pago Inicial",
  Description: "Descripción",
  PercentOfTotalAmount: "Porcentaje del Monto Total",
  Type: "Tipo",
  Phone: "Teléfono",
  Number: "Número",
  Extension: "Extensión",
  CustomerHasPriorWithThisAgency: "Cliente Tiene Historial con Esta Agencia",
  PriorCarrierId: "ID de Aseguradora Anterior",
  PriorCarrierName: "Nombre de Aseguradora Anterior",
  PriorExpirationDate: "Fecha de Vencimiento Anterior",
  PriorInsurance: "Seguro Anterior",
  PriorLiabilityLimit: "Límite de Responsabilidad Anterior",
  PriorMonthsCoverage: "Meses de Cobertura Anterior",
  ReasonForNoInsurance: "Razón para No Tener Seguro",
  Vehicle: "Vehículo",
  VehicleId: "ID del Vehículo",
  ActualCashValue: "Valor en Efectivo Real",
  AnnualMiles: "Millas Anuales",
  AssignedDriverId: "ID del Conductor Asignado",
  CoverageInformation: "Información de Cobertura",
  GaragingAddress: "Dirección de Garaje",
  GrayMarket: "Mercado Gris",
  HomingDevice: "Dispositivo de Localización",
  HoodLock: "Cerradura del Capó",
  LeasedVehicle: "Vehículo Arrendado",
  LicensePlateNumber: "Número de Placa",
  Odometer: "Odómetro",
  PercentToWork: "Porcentaje al Trabajo",
  PurchaseCost: "Costo de Compra",
  PurchaseDate: "Fecha de Compra",
  PurchaseType: "Tipo de Compra",
  RideShare: "Compartir Viaje",
  Salvaged: "Recuperado",
  Usage: "Uso",
  UsageBased: "Basado en Uso",
  Vin: "Número de VIN",
  VinEtching: "Grabado de VIN",
  Violation: "Infracción",
  Attribute1: "Atributo1",
  Attribute2: "Atributo2",
  Code: "Código",
  OccurredAt: "Ocurrió En",
  OccurredOnSameDayAsAnotherViolation:
    "Ocurrió El Mismo Día Que Otra Infracción",
  BumpLimits: "Límites de Aumento",
  CarrierInformation: "Información de la Aseguradora",
  UseExactCarrierInfo: "Usar Información Exacta de la Aseguradora",
  Products: "Productos",
  CarrierProduct: "Producto de la Aseguradora",
  AgencyId: "ID de la Agencia",
  CarrierId: "ID de la Aseguradora",
  CarrierName: "Nombre de la Aseguradora",
  ProductId: "ID del Producto",
  ProgramId: "ID del Programa",
  ProductName: "Nombre del Producto",
  ProductQuestions: "Preguntas del Producto",
  ProducerCode: "Código del Productor",
  SubProducerCode: "Código del Sub-Productor",
  CarrierUserName: "Nombre de Usuario de la Aseguradora",
  CarrierPassword: "Contraseña de la Aseguradora",
  CarrierQuoteNumber: "Número de Cotización de la Aseguradora",
  PolicyType: "Tipo de Póliza",
  MiscellaneousFees: "Tarifas Misceláneas",
  RatedDrivers: "Conductores Calificados",
  ExcludedDrivers: "Conductores Excluidos",
  Vehicles: "Vehículos",
  Term: "Plazo",
  PaymentMethod: "Método de Pago",
  NumberOfPayments: "Número de Pagos",
  DownPaymentPercentage: "Porcentaje de Pago Inicial",
  PaperlessDiscount: "Descuento Sin Papel",
  PaymentFilter: "Filtro de Pago",
  AgencyBill: "Factura de Agencia",
  EffectiveDate: "Fecha Efectiva",
  UninsuredMotoristPdLimit: "Límite PD de Motorista Sin Seguro",
  LegalExpense: "Gastos Legales",
  ExpiredLicense: "Licencia Expirada",
  LearnersPermit: "Permiso de Aprendizaje",
  Licensed: "Con Licencia",
  SuspendedLicense: "Licencia Suspendida",
  RevokedLicense: "Licencia Revocada",
  UninsuredMotoristPdDeductible: "Deducible PD de Motorista Sin Seguro",
  StackedUninsuredMotorist: "Motorista Sin Seguro Apilado",
  RoadsideLimit: "Límite de Asistencia en Carretera",
  Sr22A: "Sr22A",
  PipLimit: "Límite PIP",
  PrimaryFRPolicy: "Póliza FR Primaria",
  "Do you have": "¿Tiene usted",
  "Vehicles Information": "Información de Vehículos",
  "No vehicle added yet": "No se ha agregado ningún vehículo todavía",
  "Add Car": "Agregar Vehículo",
  "Please fill form": "Por favor, complete el formulario",
  "Drivers Information": "Información de Conductores",
  "No drivers added yet": "No se ha agregado ningún conductor todavía",
  "Add Driver": "Agregar Conductor",
  "Click on vehicle": "Haga clic en el vehículo para agregar más",
  "months": "meses",
  "Down payment today": "Pago inicial hoy",
  "Call a Licensed Agent Now": "Llame a un Agente Licenciado Ahora",
  "We'll attach your quate so you don't ropeat yourself.": "Le adjuntaremos su cotización para que no se repita.",
  "Coverage cannot be bound online. Policy effective date and price subject to underwriting.": "La cobertura no puede ser vinculada en línea. La fecha efectiva de la póliza y el precio están sujetos a la aprobación de la aseguradora.",
  "You're minutes away from getting covered": "Estás a minutos de tener cobertura",
  "Call now or request a call to complete your policy": "Llama ahora o solicita una llamada para completar tu póliza",
  "Quote Summary": "Resumen de la Cotización",
  "Quote ID": "ID de la Cotización",
  "Agents available until 8:00 PM CT today": "Agentes disponibles hasta las 8:00 PM CT hoy",
  "Mon-Sat 8a-8p CT": "Lun-Sab 8a-8p CT",
  "Call now": "Llamar ahora",
  "Start chat": "Iniciar chat",
  "Schedule for later": "Programar para más tarde"
};
